import React from 'react';
import PropTypes from 'prop-types';

export const Icon = props => {
  return (
    <svg className={`syos-icon syos-icon--${props.name}`} viewBox="0 0 16 16">
      <title>{props.label}</title>
      {props.children}
    </svg>
  );
};
Icon.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  children: PropTypes.element
};

export const IconZoomIn = () => {
  return (
    <Icon name="zoom-in" label="Zoom In">
      <path d="M12.8 8c0 0.442-0.038 0.8-0.481 0.8h-3.519v3.519c0 0.442-0.358 0.481-0.8 0.481s-0.8-0.039-0.8-0.481v-3.519h-3.519c-0.442 0-0.481-0.358-0.481-0.8s0.039-0.8 0.481-0.8h3.519v-3.519c0-0.442 0.358-0.481 0.8-0.481s0.8 0.038 0.8 0.481v3.519h3.519c0.442 0 0.481 0.358 0.481 0.8z" />
    </Icon>
  );
};

export const IconZoomOut = () => {
  return (
    <Icon name="zoom-out" label="Zoom Out">
      <path d="M12.8 8c0 0.442-0.038 0.8-0.481 0.8h-8.638c-0.442 0-0.481-0.358-0.481-0.8s0.039-0.8 0.481-0.8h8.639c0.442 0 0.48 0.358 0.48 0.8z" />
    </Icon>
  );
};

export const IconChevronUp = () => {
  return (
    <Icon name="toggle" label="Toggle">
      <path d="M12.387 9.962c-0.349 0.357-0.834 0.385-1.261 0l-3.126-2.998-3.126 2.998c-0.426 0.385-0.913 0.357-1.259 0-0.349-0.356-0.326-0.958 0-1.292 0.325-0.334 3.756-3.602 3.756-3.602 0.174-0.178 0.402-0.268 0.63-0.268s0.456 0.090 0.631 0.268c0 0 3.43 3.267 3.756 3.602s0.349 0.936 0 1.292z" />
    </Icon>
  );
};

export const IconChevronDown = () => {
  return (
    <Icon name="toggle" label="Toggle">
      <path d="M3.613 6.038c0.349-0.357 0.834-0.385 1.261 0l3.126 2.998 3.126-2.998c0.426-0.385 0.913-0.357 1.259 0 0.349 0.356 0.326 0.958 0 1.292-0.325 0.334-3.756 3.602-3.756 3.602-0.174 0.178-0.402 0.268-0.63 0.268s-0.456-0.090-0.631-0.268c0 0-3.43-3.267-3.756-3.602s-0.349-0.936 0-1.292z" />
    </Icon>
  );
};

export const IconChevronLeft = () => {
  return (
    <Icon name="toggle" label="Toggle">
      <path d="M9.962 3.613c0.357 0.349 0.385 0.834 0 1.261l-2.998 3.126 2.998 3.126c0.385 0.426 0.357 0.913 0 1.259-0.356 0.349-0.958 0.326-1.292 0-0.334-0.325-3.602-3.756-3.602-3.756-0.178-0.174-0.268-0.402-0.268-0.63s0.090-0.456 0.268-0.631c0 0 3.267-3.43 3.602-3.756s0.936-0.349 1.292 0z" />
    </Icon>
  );
};

export const IconChevronRight = () => {
  return (
    <Icon name="toggle" label="Toggle">
      <path d="M7.33 3.613c0.334 0.326 3.602 3.756 3.602 3.756 0.178 0.175 0.268 0.403 0.268 0.631s-0.090 0.456-0.268 0.63c0 0-3.267 3.431-3.602 3.756-0.334 0.326-0.936 0.349-1.292 0-0.357-0.347-0.385-0.833 0-1.259l2.998-3.126-2.998-3.126c-0.385-0.426-0.357-0.913 0-1.261s0.958-0.327 1.292 0z" />
    </Icon>
  );
};

export const IconClose = () => {
  return (
    <Icon name="close" label="Close">
      <path d="M12.656 4.281l-3.719 3.719 3.719 3.719-0.938 0.938-3.719-3.719-3.719 3.719-0.938-0.938 3.719-3.719-3.719-3.719 0.938-0.938 3.719 3.719 3.719-3.719z" />
    </Icon>
  );
};

export const IconRemove = () => {
  return (
    <Icon name="remove" label="Remove">
      <path d="M8,1.3c-3.7,0-6.7,3-6.7,6.7c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7S11.7,1.3,8,1.3z M9.4,8l2.4,2.4l-1.4,1.4L8,9.4l-2.4,2.4 l-1.4-1.4L6.6,8L4.2,5.6l1.4-1.4L8,6.6l2.4-2.4l1.4,1.4C11.8,5.6,9.4,8,9.4,8z" />
    </Icon>
  );
};

export const IconTicket = () => {
  return (
    <Icon name="ticket" label="Ticket">
      <path d="M3.925 9.233l2.841 2.842 5.214-5.214-2.842-2.841-5.213 5.213zM15.283 5.331l-1.209-1.21c-0.231 0.125-0.494 0.197-0.775 0.197-0.894 0-1.619-0.725-1.619-1.618 0-0.282 0.071-0.546 0.197-0.775l-1.209-1.21c-0.315-0.314-0.83-0.314-1.146 0l-8.808 8.808c-0.314 0.314-0.314 0.83 0 1.146l1.21 1.208c0.231-0.125 0.494-0.197 0.776-0.197 0.894 0 1.618 0.725 1.618 1.62 0 0.28-0.071 0.544-0.197 0.775l1.21 1.208c0.315 0.315 0.83 0.315 1.146 0l8.806-8.806c0.315-0.316 0.315-0.831 0-1.146zM6.766 13.375l-4.141-4.142 6.514-6.513 4.141 4.141-6.514 6.514z" />
    </Icon>
  );
};



// WEBPACK FOOTER //
// ./src/javascripts/components/Icons.js